import { useState } from 'react'
import Modal from '../common/Modal'

export default function RejectDocumentModal({
  isOpen,
  onClose,
  onConfirm,
  documentName,
  isLoading = false,
}) {
  const [rejectReason, setRejectReason] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!rejectReason.trim()) {
      setError('Please provide a reason for rejection')
      return
    }

    if (rejectReason.trim().length < 10) {
      setError('Please provide a more detailed reason (at least 10 characters)')
      return
    }

    setError('')
    onConfirm(rejectReason.trim())
  }

  const handleClose = () => {
    if (!isLoading) {
      setRejectReason('')
      setError('')
      onClose()
    }
  }

  const handleReasonChange = (e) => {
    setRejectReason(e.target.value)
    if (error) setError('')
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <div className="p-2">
        {/* Header */}
        <div className="mb-2">
          <h3 className="text-lg font-semibold text-gray-900">Reject Document</h3>
        </div>

        {/* Content */}
        <form onSubmit={handleSubmit}>
          <div>
            <p className="text-gray-700 text-sm mb-4">
              You are about to reject the document <strong>"{documentName}"</strong>. Please provide
              a clear reason for rejection to help the user understand what needs to be corrected.
            </p>

            <div className="space-y-2 mb-6">
              <label htmlFor="rejectReason" className="block text-sm font-medium text-gray-700">
                Reason for Rejection <span className="text-red-500">*</span>
              </label>
              <textarea
                id="rejectReason"
                value={rejectReason}
                onChange={handleReasonChange}
                placeholder="Please explain why this document is being rejected..."
                className={`w-full px-3 py-2 border rounded-md resize-none focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 ${
                  error ? 'border-red-300 bg-red-50' : 'border-gray-300'
                }`}
                rows={4}
                disabled={isLoading}
                autoFocus
              />
              {error && <p className="text-sm text-red-600">{error}</p>}
              <p className="text-xs text-gray-500">
                Minimum 10 characters required. Be specific about what needs to be corrected.
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="flex gap-3">
            <button
              type="button"
              onClick={handleClose}
              className="flex-1 px-4 py-2 text-gray-700 bg-background border border-gray-300 rounded-md hover:bg-neutral-200-50 transition-colors font-medium"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={isLoading || !rejectReason.trim()}
            >
              {isLoading ? (
                <div className="flex items-center justify-center gap-2">
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Rejecting...
                </div>
              ) : (
                'Reject Document'
              )}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  )
}
